import { render, staticRenderFns } from "./XemVaiTro.vue?vue&type=template&id=f508185e&"
import script from "./XemVaiTro.vue?vue&type=script&lang=js&"
export * from "./XemVaiTro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports